import breakpoints from "@/constants/breakpoints"
import useTheme from "@/hooks/useTheme"
import useWindowSize from "@/hooks/useWindowSize"
import { AppBar, Box, Container, Toolbar } from "@mui/material"
import Desktop from "./desktop"
import Mobile from "./mobile"
import * as styles from "./styles"

interface HeaderProps {
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky" | undefined
}

const View = ({ position }: HeaderProps) => {
  const { width } = useWindowSize()
  const { theme } = useTheme()

  return (
    <AppBar position={position ?? "relative"} sx={styles.appBarStyle} data-testid='menu'>
      <Box bgcolor={theme === "light" ? "white" : "blackLighter"}>
        <Container maxWidth='xl'>
          <Toolbar disableGutters sx={styles.toolbarStyle}>
            {width > breakpoints.lg ? <Desktop /> : <Mobile />}
          </Toolbar>
        </Container>
      </Box>
    </AppBar>
  )
}
export default View
